// import React from "react";
// import Navbar from "../../Components/Navbar";
// import Footer from "../../Components/Footer";

// const WhyChooseUs = () => {
//   return (
//     <div>
//       <Navbar />
//       <div className="container w-75 mx-auto my-5">
//         <h3 className="fw-bold mb-3 pt-5">
//           Let Us Handle the Culling, So You Can Focus on the Magic
//         </h3>
//         <p>
//           As a wedding photographer, you know the story is in the details—but
//           sorting through thousands of images to find the perfect ones takes
//           time. At Captureedits, we provide expert wedding photo culling
//           services to help you save hours and stay focused on what you love:
//           creat ing timeless memories for your clients.
//         </p>
//         <h3 className="fw-bold text_maincolor">What’s Included</h3>
//         <h5>Precise Selection of the Best Moments</h5>
//         <p>
//           We carefully go through your entire shoot to select only the sharpest,
//           most emotional, and visually appealing photos.
//         </p>
//         <h5>Remove Blinks, Duplicates & Missed Shots</h5>
//         <p>
//           Our trained eyes eliminate unnecessary or flawed images, giving you a
//           clean, refined gallery to edit.
//         </p>{" "}
//         <h5>Fast & Reliable Turnaround</h5>
//         <p>
//           We know deadlines matter—especially for weddings. Get your culled
//           images back fast without compromising quality.
//         </p>{" "}
//         <h5>Custom Preferences? No Problem.</h5>
//         <p>
//           Prefer more candid shots or certain poses? We follow your exact style
//           and preferences to maintain your artistic vision
//         </p>
//         <h4 className="fw-bold">Why Wedding Photographers Trust Us</h4>
//         <ul>
//           <li>
//             Save up <b>to 50% to 6-10 hours per wedding </b>
//           </li>
//           <li>Maintain a consistent storytelling style</li>
//           <li>Focus on editing the best images—not digging through them</li>
//           <li> Secure file handling and 100% confidentiality</li>
//         </ul>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default WhyChooseUs;

import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const WhyChooseUs = () => {
  const mainColor = "#008080";

  return (
    <div>
      <style>
        {`
          .text-main-color {
            color: ${mainColor};
          }
          .bg-main-color {
            background-color: ${mainColor};
          }
          .border-main-color {
            border-color: ${mainColor};
          }
          .feature-card {
            border: 1px solid #e9ecef;
            border-radius: 8px;
            padding: 1.5rem;
            margin-bottom: 1rem;
            transition: box-shadow 0.3s ease;
          }
          .feature-card:hover {
            box-shadow: 0 4px 12px rgba(0, 128, 128, 0.15);
          }
        
          .trust-section {
            background-color: #f8f9fa;
            padding: 2rem;
            border-radius: 8px;
            margin-top: 2rem;
          }
          .trust-item {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            padding: 0.5rem;
          }
          .trust-icon {
            width: 24px;
            height: 24px;
            background-color: ${mainColor};
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1rem;
            font-size: 12px;
          }
        `}
      </style>

      <Navbar />

      {/* Hero Section */}
      <div className="hero-section my-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center mt-5">
              <h2 className="fw-bold mb-4">Why Choose CaptureEdits?</h2>
              <p className="">
                At Captureedits, we don’t just edit — we enhance, elevate, and
                transform your visuals into powerful stories.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            {/* What's Included Section */}
            <div className="row">
              <div className="col-md-6">
                <div className="feature-card">
                  <h5 className="text-main-color fw-bold">
                    ✔ Professional Quality
                  </h5>
                  <p>
                    Every photo and video is edited by skilled professionals
                    using industry-leading tools and techniques.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="feature-card">
                  <h5 className="text-main-color fw-bold">✔ Fast Turnaround</h5>
                  <p>
                    We value your time. Get high-quality results delivered on
                    schedule — every time.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="feature-card">
                  <h5 className="text-main-color fw-bold">
                    ✔ Customized to Your Style
                  </h5>
                  <p>
                    Your vision matters. We adapt our editing style to match
                    your brand and creative direction.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="feature-card">
                  <h5 className="text-main-color fw-bold">
                    ✔ High-Volume Capability
                  </h5>
                  <p>
                    Need 100 or 10,000 images? We handle bulk projects with
                    precision and consistency
                  </p>
                </div>
              </div>{" "}
              <div className="col-md-6">
                <div className="feature-card">
                  <h5 className="text-main-color fw-bold">
                    ✔ Affordable Pricing{" "}
                  </h5>
                  <p>
                    Get premium editing services without overpaying.
                    Transparent, flexible, and budget-friendly.
                  </p>
                </div>
              </div>{" "}
              <div className="col-md-6">
                <div className="feature-card">
                  <h5 className="text-main-color fw-bold">
                    ✔ Dedicated Support
                  </h5>
                  <p>
                    We’re with you every step — responsive, reliable, and ready
                    to make revisions until you’re 100% satisfied.
                  </p>
                </div>
              </div>
            </div>

            {/* Why Trust Us Section */}
            <div className="trust-section">
              <h3 className="text-main-color fw-bold text-center mb-4">
                Why Wedding Photographers Trust Us
              </h3>

              <div className="row">
                <div className="col-md-12">
                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>
                      Save up <strong>6-10 hours per wedding</strong>
                    </span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>Maintain a consistent storytelling style</span>
                  </div>

                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>
                      Focus on editing the best images—not digging through them
                    </span>
                  </div>
                  <div className="trust-item">
                    <div className="trust-icon">✓</div>
                    <span>Secure file handling and 100% confidentiality</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default WhyChooseUs;
